import { render, staticRenderFns } from "./ProductParamImageDialog.vue?vue&type=template&id=8323c1d0&scoped=true"
import script from "./ProductParamImageDialog.vue?vue&type=script&lang=js"
export * from "./ProductParamImageDialog.vue?vue&type=script&lang=js"
import style0 from "./ProductParamImageDialog.vue?vue&type=style&index=0&id=8323c1d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8323c1d0",
  null
  
)

export default component.exports